import { IApplicationState } from '../../types/redux';

/**
 * Выбирает все Фотогалереи
 */
export const selectPostContentPhotoGalleries = ({ postContentPhotoGalleries }: IApplicationState) =>
  postContentPhotoGalleries.items;
